export const ContractAddress: any = {
  BEP20: {
    'BabyDoge': {
      'tokenDecimal': 9,
      'contractId': '0xc748673057861a797275cd8a068abb95a902e8de'
    },
    'MBOX': {
      'tokenDecimal': 18,
      'contractId': '0x3203c9e46ca618c8c1ce5dc67e7e9d75f5da2377'
    },
    'CAKE': {
      'tokenDecimal': 18,
      'contractId': '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'
    },
    'TLM': {
      'tokenDecimal': 4,
      'contractId': '0x2222227e22102fe3322098e4cbfe18cfebd57c95'
    },
    'TWT': {
      'tokenDecimal': 18,
      'contractId': '0x4b0f1812e5df2a09796481ff14017e6005508003'
    },
    'BTC': {
      'tokenDecimal': 18,
      'contractId': '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c'
    },
    'ETH': {
      'tokenDecimal': 18,
      'contractId': '0x2170ed0880ac9a755fd29b2688956bd959f933f8'
    },
    'LTC': {
      'tokenDecimal': 18,
      'contractId': '0x4338665cbb7b2485a8855a139b75d5e34ab0db94'
    },
    'BCH': {
      'tokenDecimal': 18,
      'contractId': '0x8ff795a6f4d97e7887c79bea79aba5cc76444adf'
    },
    'XRP': {
      'tokenDecimal': 18,
      'contractId': '0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe'
    },
    'TRX': {
      'tokenDecimal': 18,
      'contractId': '0x85eac5ac2f758618dfa09bdbe0cf174e7d574d5b'
    },
    'IGU': {
      'tokenDecimal': 18,
      'contractId': '0x201bc9f242f74c47bbd898a5dc99cdcd81a21943'
    },
    'DOGE': {
      'tokenDecimal': 8,
      'contractId': '0xba2ae424d960c26247dd6c32edc70b295c744c43'
    },
    'ADA': {
      'tokenDecimal': 18,
      'contractId': '0x3ee2200efb3400fabb9aacf31297cbdd1d435d47'
    },
    'XLM': {
      'tokenDecimal': 18,
      'contractId': '0x43c934a845205f0b514417d757d7235b8f53f1b9'
    },
    'EOS': {
      'tokenDecimal': 18,
      'contractId': '0x56b6fb708fc5732dec1afc8d8556423a2edccbd6'
    },
    'XTZ': {
      'tokenDecimal': 18,
      'contractId': '0x16939ef78684453bfdfb47825f8a5f714f12623a'
    },
    'SHIB': {
      'tokenDecimal': 18,
      'contractId': '0x2859e4544c4bb03966803b044a93563bd2d0dd4d'
    },
    'AXS': {
      'tokenDecimal': 18,
      'contractId': '0x715d400f88c167884bbcc41c5fea407ed4d2f8a0'
    },
    'MANA': {
      'tokenDecimal': 18,
      'contractId': '0x26433c8127d9b4e9b71eaa15111df99ea2eeb2f8'
    },
    'GALA': {
      'tokenDecimal': 18,
      'contractId': '0x7ddee176f665cd201f93eede625770e2fd911990'
    },
    'POL': {
      'tokenDecimal': 18,
      'contractId': '0xcc42724c6683b7e57334c4e856f4c9965ed682bd'
    },
    'CELR': {
      'tokenDecimal': 18,
      'contractId': '0x1f9f6a696c6fd109cd3956f45dc709d2b3902163'
    },
    'FTM': {
      'tokenDecimal': 18,
      'contractId': '0xad29abb318791d579433d831ed122afeaf29dcfe'
    },
    'DOT': {
      'tokenDecimal': 18,
      'contractId': '0x7083609fce4d1d8dc0c979aab8c869ea2c873402'
    },
    'USDT': {
      'tokenDecimal': 18,
      'contractId': '0x55d398326f99059ff775485246999027b3197955'
    },
    'ALICE': {
      'tokenDecimal': 6,
      'contractId': '0xac51066d7bec65dc4589368da368b212745d63e8'
    },
    'MKR': {
      'tokenDecimal': 18,
      'contractId': '0x5f0da599bb2cccfcf6fdfd7d81743b6020864350'
    },
    'LINK': {
      'tokenDecimal': 18,
      'contractId': '0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd'
    },
    'AAVE': {
      'tokenDecimal': 18,
      'contractId': '0xfb6115445bff7b52feb98650c87f44907e58f802'
    },
    'YFI': {
      'tokenDecimal': 18,
      'contractId': '0x88f1a5ae2a3bf98aeaf342d26b30a79438c9142e'
    },
    'APE': {
      'tokenDecimal': 18,
      'contractId': '0xc762043e211571eb34f1ef377e5e8e76914962f9'
    },
    'SOL': {
      'tokenDecimal': 18,
      'contractId': '0x570a5d26f7765ecb712c0924e4de545b89fd43df'
    },
    'SAND': {
      'tokenDecimal': 18,
      'contractId': '0x67b725d7e342d7b611fa85e859df9697d9378b2e'
    },
    'FLOKI': {
      'tokenDecimal': 9,
      'contractId': '0xfb5b838b6cfeedc2873ab27866079ac55363d37e'
    },
    'FEG': {
      'tokenDecimal': 9,
      'contractId': '0xbededDf2eF49E87037c4fb2cA34d1FF3D3992A11'
    },
    'ALPINE': {
      'tokenDecimal': 8,
      'contractId': '0x287880ea252b52b63cc5f40a2d3e5a44aa665a76'
    },
    'USDC': {
      'tokenDecimal': 18,
      'contractId': '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d'
    },
    'BUSD': {
      'tokenDecimal': 18,
      'contractId': '0xe9e7cea3dedca5984780bafc599bd69add087d56'
    },
    'BAKE': {
      'tokenDecimal': 18,
      'contractId': '0xe02df9e3e622debdd69fb838bb799e3f168902c5'
    },
    'CGPT': {
      'tokenDecimal': 18,
      'contractId': '0x9840652dc04fb9db2c43853633f0f62be6f00f98'
    },
    'ID': {
      'tokenDecimal': 18,
      'contractId': '0x2dff88a56767223a5529ea5960da7a3f5f766406'
    },
    'HOOK': {
      'tokenDecimal': 18,
      'contractId': '0xa260e12d2b924cb899ae80bb58123ac3fee1e2f0'
    },
    'BTT': {
      'tokenDecimal': 18,
      'contractId': '0x352cb5e19b12fc216548a2677bd0fce83bae434b'
    },
    'INJ': {
      'tokenDecimal': 18,
      'contractId': '0xa2b726b1145a4773f68593cf171187d8ebe4d495'
    },
    'GMT': {
      'tokenDecimal': 8,
      'contractId': '0x3019bf2a2ef8040c242c9a4c5c4bd4c81678b2a1'
    },
    'FLUX': {
      'tokenDecimal': 8,
      'contractId': '0xaff9084f2374585879e8b434c399e29e80cce635'
    },
    'CYBER': {
      'tokenDecimal': 18,
      'contractId': '0x14778860e937f509e651192a90589de711fb88a9'
    },
    'STG': {
      'tokenDecimal': 18,
      'contractId': '0xb0d502e938ed5f4df2e681fe6e419ff29631d62b'
    }
  },
  ERC20: {
    'SHIB': {
      'tokenDecimal': 18,
      'contractId': '0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce'
    },
    'AXS': {
      'tokenDecimal': 18,
      'contractId': '0xbb0e17ef65f82ab018d8edd776e8dd940327b28b'
    },
    'MANA': {
      'tokenDecimal': 18,
      'contractId': '0x0f5d2fb29fb7d3cfee444a200298f468908cc942'
    },
    'SAND': {
      'tokenDecimal': 18,
      'contractId': '0x3845badade8e6dff049820680d1f14bd3903a5d0'
    },
    'ELON': {
      'tokenDecimal': 18,
      'contractId': '0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3'
    },
    'BabyDoge': {
      'tokenDecimal': 18,
      'contractId': '0xac57de9c1a09fec648e93eb98875b212db0d460b'
    },
    'CHZ': {
      'tokenDecimal': 18,
      'contractId': '0x3506424f91fd33084466f402d5d97f05f8e3b4af'
    },
    'USDT': {
      'tokenDecimal': 6,
      'contractId': '0xdAC17F958D2ee523a2206206994597C13D831ec7'
    },
    'GALA': {
      'tokenDecimal': 8,
      'contractId': '0xd1d2eb1b1e90b638588728b4130137d262c87cae'
    },
    'APE': {
      'tokenDecimal': 18,
      'contractId': '0x4d224452801aced8b2f0aebe155379bb5d594381'
    },
    'CRO': {
      'tokenDecimal': 8,
      'contractId': '0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b'
    },
    'KISHU': {
      'tokenDecimal': 9,
      'contractId': '0xa2b4c0af19cc16a6cfacce81f192b024d625817d'
    },
    'FTM': {
      'tokenDecimal': 18,
      'contractId': '0x4e15361fd6b4bb609fa63c81a2be19d873717870'
    },
    'POL': {
      'tokenDecimal': 18,
      'contractId': '0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0'
    },
    'YFI': {
      'tokenDecimal': 18,
      'contractId': '0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e'
    },
    'CELR': {
      'tokenDecimal': 18,
      'contractId': '0x4f9254c83eb525f9fcf346490bbb3ed28a81c667'
    },
    'AUDIO': {
      'tokenDecimal': 18,
      'contractId': '0x18aaa7115705e8be94bffebde57af9bfc265b998'
    },
    'AAVE': {
      'tokenDecimal': 18,
      'contractId': '0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9'
    },
    'GRT': {
      'tokenDecimal': 18,
      'contractId': '0xc944e90c64b2c07662a292be6244bdf05cda44a7'
    },
    'OMG': {
      'tokenDecimal': 18,
      'contractId': '0xd26114cd6ee289accf82350c8d8487fedb8a0c07'
    },
    'LINK': {
      'tokenDecimal': 18,
      'contractId': '0x514910771af9ca656af840dff83e8264ecf986ca'
    },
    'CRV': {
      'tokenDecimal': 18,
      'contractId': '0xd533a949740bb3306d119cc777fa900ba034cd52'
    },
    'MKR': {
      'tokenDecimal': 18,
      'contractId': '0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2'
    },
    'DYDX': {
      'tokenDecimal': 18,
      'contractId': '0x92d6c1e31e14520e676a687f0a93788b716beff5'
    },
    'ALICE': {
      'tokenDecimal': 6,
      'contractId': '0xac51066d7bec65dc4589368da368b212745d63e8'
    },
    'KCS': {
      'tokenDecimal': 6,
      'contractId': '0xf34960d9d60be18cc1d5afc1a6f012a723a28811'
    },
    'SLP': {
      'tokenDecimal': 0,
      'contractId': '0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25'
    },
    'USDC': {
      'tokenDecimal': 6,
      'contractId': '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48'
    },
    'CAW': {
      'tokenDecimal': 18,
      'contractId': '0xf3b9569f82b18aef890de263b84189bd33ebe452'
    },
    'UNI': {
      'tokenDecimal': 18,
      'contractId': '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984'
    },
    'DC': {
      'tokenDecimal': 18,
      'contractId': '0x7b4328c127b85369d9f82ca0503b000d09cf9180'
    },
    'MNET': {
      'tokenDecimal': 18,
      'contractId': '0x829c97092c0cc92efe7397dd3ddb831cc5835bae'
    },
    'PAXG': {
      'tokenDecimal': 18,
      'contractId': '0x45804880de22913dafe09f4980848ece6ecbaf78'
    },
    'BNS': {
      'tokenDecimal': 8,
      'contractId': '0x19e2a43fbbc643c3b2d9667d858d49cad17bc2b5'
    },
    'LRC': {
      'tokenDecimal': 18,
      'contractId': '0xbbbbca6a901c926f240b89eacb641d8aec7aeafd'
    },
    '1INCH': {
      'tokenDecimal': 18,
      'contractId': '0x111111111117dc0aa78b770fa6a738034120c302'
    },
    'FORTH': {
      'tokenDecimal': 18,
      'contractId': '0x77fba179c79de5b7653f68b5039af940ada60ce0'
    },
    'WOJAK': {
      'tokenDecimal': 18,
      'contractId': '0x5026f006b85729a8b14553fae6af249ad16c9aab'
    },
    'PEPE': {
      'tokenDecimal': 18,
      'contractId': '0x6982508145454ce325ddbe47a25d4ec3d2311933'
    },
    'ID': {
      'tokenDecimal': 18,
      'contractId': '0x2dff88a56767223a5529ea5960da7a3f5f766406'
    },
    'LINA': {
      'tokenDecimal': 18,
      'contractId': '0x3e9bc21c9b189c09df3ef1b824798658d5011937'
    },
    'RNDR': {
      'tokenDecimal': 18,
      'contractId': '0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24'
    },
    'RPL': {
      'tokenDecimal': 18,
      'contractId': '0xd33526068d116ce69f19a9ee46f0bd304f21a51f'
    },
    'AGIX': {
      'tokenDecimal': 8,
      'contractId': '0x5b7533812759b45c2b44c19e320ba2cd2681b542'
    },
    'ARKM': {
      'tokenDecimal': 18,
      'contractId': '0x6e2a43be0b1d33b726f0ca3b8de60b3482b8b050'
    },
    'FXS': {
      'tokenDecimal': 18,
      'contractId': '0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0'
    },
    'QNT': {
      'tokenDecimal': 18,
      'contractId': '0x4a220e6096b25eadb88358cb44068a3248254675'
    },
    'INJ': {
      'tokenDecimal': 18,
      'contractId': '0xe28b3b32b6c345a34ff64674606124dd5aceca30'
    },
    'SNX': {
      'tokenDecimal': 18,
      'contractId': '0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f'
    },
    'FLUX': {
      'tokenDecimal': 8,
      'contractId': '0x720cd16b011b987da3518fbf38c3071d4f0d1495'
    },
    'OVR': {
      'tokenDecimal': 18,
      'contractId': '0x21bfbda47a0b4b5b1248c767ee49f7caa9b23697'
    },
    'KNC': {
      'tokenDecimal': 18,
      'contractId': '0xdefa4e8a7bcba345f687a2f1456f5edd9ce97202'
    },
    'CYBER': {
      'tokenDecimal': 18,
      'contractId': '0x14778860e937f509e651192a90589de711fb88a9'
    },
    'SYN': {
      'tokenDecimal': 18,
      'contractId': '0x0f2d719407fdbeff09d87557abb7232601fd9f29'
    },
    'DAI': {
      'tokenDecimal': 18,
      'contractId': '0x6b175474e89094c44da98b954eedeac495271d0f'
    },
    'PEOPLE': {
      'tokenDecimal': 18,
      'contractId': '0x7a58c0be72be218b41c608b7fe7c5bb630736c71'
    },
    'FET': {
      'tokenDecimal': 18,
      'contractId': '0xaea46a60368a7bd060eec7df8cba43b7ef41ad85'
    },
    'METIS': {
      'tokenDecimal': 18,
      'contractId': '0x9e32b13ce7f2e80a01932b42553652e053d6ed8e'
    },
    'ENA': {
      'tokenDecimal': 18,
      'contractId': '0x57e114b691db790c35207b2e685d4a43181e6061'
    },
    'AEVO': {
      'tokenDecimal': 18,
      'contractId': '0xb528edbef013aff855ac3c50b381f253af13b997'
    },
    'BADGER': {
      'tokenDecimal': 18,
      'contractId': '0x3472a5a71965499acd81997a54bba8d852c6e53d'
    },
    'ONDO': {
      'tokenDecimal': 18,
      'contractId': '0xfaba6f8e4a5e8ab82f62fe7c39859fa577269be3'
    }
  },
  POLYGON: {
    'GNS': {
      'tokenDecimal': 18,
      'contractId': '0xe5417af564e4bfda1c483642db72007871397896'
    },
    'USDT': {
      'tokenDecimal': 6,
      'contractId': '0xc2132d05d31c914a87c6611c10748aeb04b58e8f'
    }
  },
  OPTIMISM:{
    'OP':{
      'tokenDecimal': 18,
      'contractId': '0x4200000000000000000000000000000000000042'
    }
  },
  ARBITRUM: {
    'GMX': {
      'tokenDecimal': 18,
      'contractId': '0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a'
    },
    'ARB': {
      'tokenDecimal': 18,
      'contractId': '0x912ce59144191c1204e64559fe8253a0e49e6548'
    },
    'AIDOGE': {
      'tokenDecimal': 6,
      'contractId': '0x09e18590e8f76b6cf471b3cd75fe1a1a9d2b2c2b'
    },
    'REKT': {
      'tokenDecimal': 6,
      'contractId': '0x1d987200df3b744cfa9c14f713f5334cb4bc4d5d'
    },
    'RDNT': {
      'tokenDecimal': 18,
      'contractId': '0x3082cc23568ea640225c2467653db90e9250aaa0'
    },
    'GNS': {
      'tokenDecimal': 18,
      'contractId': '0x18c11fd286c5ec11c3b683caa813b77f5163a122'
    }
  }
};

